import { type Pinia, type Store, getActivePinia } from 'pinia'

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>
}

export function useResetStore() {
  const pinia = getActivePinia() as ExtendedPinia

  const resetStore: Record<string, () => void> = {}

  pinia._s.forEach((store, name) => {
    resetStore[name] = () => store.$reset()
  })

  resetStore.all = () => pinia._s.forEach((store) => store.$reset())

  resetStore.clearData = () =>
    Array.from(pinia._s.entries())
      .filter(([name]) => name !== 'auth')
      .forEach(([_, store]) => store.$reset())

  return resetStore
}
